import _ from 'lodash';
// eslint-disable-next-line
const valEmpty = (obj: any) => {
  let result = {};
  _.forIn(obj, (v, k) => {
    if (_.isString(v) && _.isEmpty(v)) {
      result = _.assign(result, {[k]: false});
    } else {
      result = _.assign(result, {[k]: true});
    }
  });
  return result;
};

const valPattern = (value: string | undefined, name: string) => {
  return (reg: RegExp) => {
    return _.isUndefined(value) ? {[name]: false} : {[name]: reg.test(value)};
  };
};
// eslint-disable-next-line
const flatError = (obj: any) => {
  const flat = _.values(obj);
  return _.every(flat, (v) => _.isEqual(v, true));
};
// check contains http or not
const checkHttpAddress =  (url:string) => {
  const subStr = url.substring(0,4);
  if(subStr === "http"){
    return true;
  }
  return false
}

export {valEmpty, valPattern, flatError,checkHttpAddress};
